import { Component, Input, OnInit } from '@angular/core';
import { Dictionary } from '../../../../types/dictionary.type';
import { ComponentConfiguration } from '../../models/component-config.model';
import { PhoneViewComponent } from '../phone-view/phone-view.component';

export type ClientDetailsItems = 'person'
  | 'location'
  | 'phone'
  | 'date'
  | 'businessName'
  | 'email';

@Component({
  selector: 'app-order-client-details-view',
  templateUrl: './order-client-details-view.component.html',
})
export class OrderClientDetailsViewComponent implements OnInit {
  @Input() personName: string;
  @Input() location: string;
  @Input() phone: string;
  @Input() date: string;
  @Input() businessName: string;
  @Input() email: string;

  @Input() config: Dictionary<ClientDetailsItems, ClientDetailsModel> = {};
  items: ClientDetailsModel[] = [];

  getConfig = (config: Dictionary<ClientDetailsItems, ClientDetailsModel>) => ({
    businessName: {
      config: {
        icon: 'account_balance',
        withIcon: true,
        isDisplayed: true,
        ...(config.location && config.location.config || {}),
      },
    },
    person: {
      config: {
        icon: 'person',
        withIcon: true,
        isDisplayed: true,
        ...(config.person && config.person.config || {}),
      },
    },
    location: {
      config: {
        icon: 'location_on',
        withIcon: true,
        isDisplayed: true,
        ...(config.location && config.location.config || {}),
      },
    },
    phone: {
      config: {
        componentConfig: <ComponentConfiguration> { componentType: PhoneViewComponent, withParseData: true, },
        icon: 'phone',
        withIcon: false,
        isDisplayed: true,
        ...(config.phone && config.phone.config || {}),
      },
    },
    date: {
      config: {
        icon: 'calendar_today',
        withIcon: true,
        isDisplayed: true,
        isLate: false,
        ...(config.date && config.date.config || {}),
      },
    },
    email: {
      config: {
        icon: 'email',
        withIcon: true,
        isDisplayed: true,
        ...(config.phone && config.phone.config || {}),
      },
    },
  })

  ngOnInit() {
    this.config = this.getConfig(this.config);

    this.config['person'].model = this.personName;
    this.config['location'].model = this.location;
    this.config['phone'].model = this.phone && { phone: this.phone } || undefined;
    this.config['date'].model = this.date;
    this.config['businessName'].model = this.businessName;
    this.config['email'].model = this.email;

    this.items = Object.values(this.config).filter(x => x.config.isDisplayed);
  }
}

export class ClientDetailsModel {
  model?: string | Record<string, unknown>;
  config: ClientDetailsConfiguration;
}

class ClientDetailsConfiguration {
  icon?: string;
  isDisplayed: boolean;
  isLate?: boolean;
  withTooltip?: boolean;
  withTooltipText?: string;
  withIcon?: boolean;
}
